// Shared category palette + TTS helper for the Phrasebook feature (catalog,
// per-language browse, and phrase-detail pages) — mirrors the mobile app's
// _kCategoryIconPalette/_kCategoryColorPalette in
// lib/features/phrasebook/presentation/phrasebook_screen.dart so a category
// renders with the same color/glyph identity on both platforms.
export const CATEGORY_EMOJI_PALETTE = ['👋', '🤝', '💬', '🎧', '✈️', '🛍️', '🍽️', '🔢'];
export const CATEGORY_COLOR_PALETTE = [
  '#7C3AED', '#DB2777', '#2563EB', '#EA580C', '#0D9488', '#16A34A', '#D97706', '#9333EA',
];

export function emojiForCategoryIndex(index) {
  return index < 0 ? '🌐' : CATEGORY_EMOJI_PALETTE[index % CATEGORY_EMOJI_PALETTE.length];
}

export function colorForCategoryIndex(index) {
  return index < 0 ? '#4F46E5' : CATEGORY_COLOR_PALETTE[index % CATEGORY_COLOR_PALETTE.length];
}

let synth = null;
function getSynth() {
  if (synth === null) {
    synth = typeof window !== 'undefined' && 'speechSynthesis' in window ? window.speechSynthesis : false;
  }
  return synth || null;
}

// Mirrors VocabularyPage.jsx's speakText — same Web Speech API call shape,
// duplicated rather than imported since that one is a page-local closure.
export function speakPhrase(ttsCode, text) {
  const engine = getSynth();
  if (!engine || !text) return;
  try {
    engine.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = ttsCode || '';
    utterance.rate = 0.95;
    utterance.onerror = () => {};
    engine.speak(utterance);
  } catch {
    // Speech synthesis can throw on some browsers/voices — never let a
    // speak button crash the page.
  }
}
